import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import LetestContact from "./LetestContact";
import TopContacts from "./TopRefers"
import ContactConnect from "./ContactConnect"
import ColumnWithDataLabels from "./ColumnWithDataLabels"
import PieChart from "./PieChart"
import BarChart from "./BarChart"
import UpcomingFollow from "./Upcoming-follow"
import LeadFeedback from "./LeedFeedback"
import allImg from "../../assets/img/all.png"
import networkImg from "../../assets/img/network.png"
import vipImg from "../../assets/img/vip.png"
import RSPieChart from "components/charts/RSPieChart";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle
} from "reactstrap"
import RsAdNew from "components/buttons/Adnew";
import RsCard from "components/Rscards/Rscard";
import RsCardImg from "components/Rscards/Rscard-img";
import Moment from "react-moment";
import { API_URL } from "helpers/app_url";
import axios from "axios";

class Dashboard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      upcomingActivities:[],
      reports: [
        { title: "# Contacts", iconClass: "bx bx-copy-alt", description: "loading...." },
        { title: "VIP Contacts", iconClass: "bx bx-purchase-tag-alt", description: "loading...." },
        { title: "Referrals generated this year", iconClass: "bx bx-purchase-tag-alt", description: "loading...." },
        // { title: "Lead to client conversion", iconClass: "bx bx-plus-medical", description: "22%" },
      ],
    }
  }

  componentDidMount() {
   
    this.fetchLeadSourceData();
    this.fetchContactCountDashboardByAgent();
   
  }
    fetchContactCountDashboardByAgent = async () => {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const str = `Bearer ${token}`;
  
      try {
          const response = await axios.get(`${API_URL}Contact/getContactCountDashboardByAgentQuery`, {
              params: {
                  agentId: localStorage.getItem("userId"),
                 
              },
              headers: { Authorization: str }
          });
  
          if (response.data && Array.isArray(response.data)) {
              const totalContacts = response.data.find(item => item.sources === "Total")?.counts || 0;
              const vipContacts = response.data.find(item => item.sources === "Hot")?.counts || 0;
              const reffContacts = response.data.find(item => item.sources === "Warm")?.counts || 0;
          
              this.setState(prevState => ({
                  reports: prevState.reports.map(report => {
                      if (report.title === "# Contacts") return { ...report, description: totalContacts };
                      if (report.title === "VIP Contacts") return { ...report, description: vipContacts };
                      if (report.title === "Referrals generated this year") return { ...report, description: reffContacts };
                      return report;
                  })
              }));
          }
      } catch (error) {
          console.error("Error fetching lead counts:", error);
      }
  };
  fetchLeadSourceData = async () => {
    const agentId = localStorage.getItem("userId");
    const year = "2025";
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}Contact/getContactClassificationDashboardByAgentQuery?agentId=${agentId}`;
    try {
      const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } });
        if (response.data && Array.isArray(response.data)) {
          const sources = response.data.map(item => item.sources);
          const counts = response.data.map(item => item.counts);
        this.setState({
          leadSourceData: {
            series: counts,
            options: {
              chart: { type: "pie" },
              labels: sources,
              colors: ["#66C2A5", "#FFD92F", "#A6D854", "#E78AC3"],
              legend: {
                show: true,
                position: "bottom",
                horizontalAlign: "center",
                verticalAlign: "middle",
                floating: false,
                fontSize: "14px",
                offsetX: 0,
                offsetY: -10,
              },
              responsive: [{ breakpoint: 600, options: { chart: { height: 440 }, legend: { show: false } } }],
            },
          },
        });
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  };
  render() {
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">

            <Row className="project-header mb20">
              <Col xl="7">
                <Breadcrumbs
                  title={this.props.t("Contact")}
                  breadcrumbItem={this.props.t("Contact Dashboard")}
                />
              </Col>
              <Col xl="5">
                <div className="pt-2 float-end mt-2">

                  <div className="">
                  
                    <RsAdNew to="/contact/import-contact" className="btn btn-light btn-md me-2" iconClass="dripicons-download">Import Contact</RsAdNew>
                  </div>

                </div>



              </Col>

            </Row>
          <Row>
          <Col xl="12">
          <Row className="mb20 mt-3">
            
            {this.state.reports.map((report, key) => (
              <Col md="4" key={key}>
                <RsCard title={report.title} description={report.description} iconClass={report.iconClass} />
              </Col>
            ))}
          </Row>

       
            </Col>
            </Row>
<Row>
  <Col lg="12">
                 <Card style={{marginTop:20}}>
                              <Row>
                                <Col sm="4">
                                 {this.state.leadSourceData && <RSPieChart title="Contacts by classification" {...this.state.leadSourceData} />} 
                                </Col>
                              <Col lg="8">
                              <div className="card">
                            <div className="card-body">
                                <div className="card-title mb-4 float-start">Upcoming Activity</div>
                                <div className="clearfix"></div>
                               <div className="table-responsive">
                                        <table className="table mb-0 table">
                                          <thead>
                                            <tr>
                                              <th>Date</th>
                                              <th>Name</th>
                                              <th>Type </th>
                                              <th>Details</th>
                                              </tr>
                                              </thead>
                                              <tbody>
                                            {this.state.upcomingActivities && this.state.upcomingActivities.length > 0 ? (
                                              this.state.upcomingActivities.map((activity, index) => (
                                                <tr key={index}>
                                                  <td><Moment format="DD MMM YY">{activity.addedDate	}</Moment></td>
                                                  <td>{activity.leadName}</td>
                                                  <td>{activity.activityType}</td>
                                                  <td>{activity.activityRemarks}</td>
                                                </tr>
                                              ))
                                            ) : (
                                              <tr>
                                                <td colSpan="4" style={{ textAlign: "center" }}>No activities found</td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                               </div>
                            </div>
                            </div>
                              </Col>
                              <Col lg="4">
                                {/* <RSPieChart title="Loss Report" {...this.state.leadStageData} /> */}
                                </Col>
                              </Row>
                            </Card>
  </Col>
</Row>
        

            <Row>
              <Col lg="12">
                <LetestContact />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
Dashboard.propTypes = {
  t: PropTypes.any

}
export default connect()(withTranslation()(Dashboard))
